import React from 'react';
import { getComponentClasses } from '../../utils/app';

export interface Props {
    children: React.ReactNode;
    variations?: string[];
}

const PillGroup = ({ children, variations }: Props) => (
    <div className={getComponentClasses('pill-group', variations)}>
        {React.Children.map(children, child => (
            <div className="pill-group__item">{child}</div>
        ))}
    </div>
);

export default PillGroup;
